<template>
    <el-dialog
        title="学员选择"
        :visible.sync="dialogVisible"
        append-to-body
        width="50%"
        :before-close="handleClose"
    >
        <div class="dialogBody">
            <div  class="search-content conditionSearchBox">
                <div class="conditionItem mr-20">
                    <el-input size="medium"  prefix-icon="el-icon-search" placeholder="学员名称" v-model="params.condition.keyword" clearable></el-input>
                </div>
                <div class="conditionItem">
                    <el-button type="hollowOut" @click="triggerSearch">
                        <i class="el-icon-search mr-5"></i>查询
                    </el-button>
                </div>
            </div>
            
            <div class="studentCont">
                <div class="item" :class="item.isCheck?'active':''" @click="chooseStu(item)" v-for="(item,index) in studentsList" :key="index">{{item.name}}</div>
            </div>
            <div class="selectStu ">
                <el-tag
                    @close="delTag(tag)"
                    v-for="tag in selectList"
                    :key="tag.name"
                    closable
                    >
                    {{tag.name}}
                </el-tag>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit"
                >确 定</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import {getClassStudentListBySelect} from '@/api/measApi/teachManagement.js'
export default {
    data(){
        return {
            params: {
                condition: {
                    // keyword: '',
                    // status: ''
                    classcode: '',
                    coursecode: '',
                    ispaging: false,
                    keyword: '',
                    status: 0
                },
                page: 1,
                pagesize: 10
            },
            stuParams: {
                
            },
            studentsList: [
            ],
            selectList: [],
            dialogVisible: false
        }
    },
    methods: {
        init(info,coursecode,classCode,status){
            this.selectList = []
            this.studentsList = []
            this.params.page = 1
            this.params.condition.keyword = '' 
            this.dialogVisible = true
            this.params.condition.classcode = classCode
            this.params.condition.coursecode = coursecode
            this.params.condition.status = status
            if(info && info.length>0){
                this.selectList = info
            }
            this.getClassStudentListBySelect()
        },
        triggerSearch(){
            this.params.page = 1
            this.getClassStudentListBySelect()
        },
        getClassStudentListBySelect(){
            getClassStudentListBySelect(this.params).then(res => {
                console.log(res,'res')
                res.data.forEach(item => {
                    item.isCheck = false
                })
                this.studentsList = JSON.parse(JSON.stringify(res.data))
                if(this.selectList.length>0){
                    this.studentsList.forEach(item => {
                        this.selectList.forEach(itm => {
                            if(item.studentcode == itm.studentcode){
                                item.isCheck = true
                            }
                        })
                    })
                }
                
            })
        },
        handleClose(){
            this.dialogVisible = false
            this.selectList = []
            this.studentsList = []
            this.params.page = 1
            this.params.condition.keyword = '' 
        },
        chooseStu(item){
            item.isCheck = !item.isCheck
            this.selectList = this.studentsList.filter(item => {
                return item.isCheck
            })
        },
        delTag(val){
            val.isCheck = false
            this.selectList = this.selectList.filter(item => {
                return item.isCheck
            })
            this.studentsList.forEach(item => {
                if(item.name === val.name){
                    item.isCheck = false
                }
            })
        },
        submit(){
            this.$emit('getStuData', JSON.parse(JSON.stringify(this.selectList)))
            this.dialogVisible = false
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-tag{
    height: 26px;
    font-size: 12px;
    line-height: 26px;
    // margin-right: 10px;
    cursor: pointer;
    margin: 10px 10px 0 0!important;
}
.active{
    color: white!important;
    background: #0B75FA!important;
}
.dialogBody{
    // padding: 20px;
    .studentCont{
        display: flex;
        flex-wrap: wrap;
        .item{
            padding: 0 10px;
            line-height: 28px;
            text-align: center;
            // margin: 10px 0;
            margin-bottom: 10px;
            margin-right: 10px;
            height: 28px;
            background: #F6F7FB;
            cursor: pointer;
            color: #999999;
            border-radius: 4px 4px 4px 4px;
            font-size: 12px;
        }
    }
    .selectStu{
        border-top: 1px solid #DFE6EC;
        padding: 20px 0;
    }
}
</style>